import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { CardFooter } from '@/components/ui/card'
import { Small } from '@/components/ui/typography'

interface AdSelectionPaginationFooterProps {
    startIndex: number
    endIndex: number
    totalCount: number
    currentPage: number
    totalPages: number
    onPrevious: () => void
    onNext: () => void
}

export function AdSelectionPaginationFooter({
    startIndex,
    endIndex,
    totalCount,
    currentPage,
    totalPages,
    onPrevious,
    onNext,
}: AdSelectionPaginationFooterProps) {
    return (
        <CardFooter className="flex shrink-0 items-center justify-between border-t px-3 py-2 bg-secondary border-border">
            <Small className="text-xs text-muted-foreground">
                Showing {startIndex + 1} to {endIndex} of {totalCount} ads
            </Small>
            <div className="flex items-center gap-1.5">
                <Button
                    variant="outline"
                    size="sm"
                    className="h-7 px-2"
                    onClick={onPrevious}
                    disabled={currentPage === 0}
                >
                    <ChevronLeft className="size-4" />
                    <span className="sr-only">Previous Page</span>
                </Button>
                <Small className="text-xs text-foreground">
                    Page {currentPage + 1} of {totalPages}
                </Small>
                <Button
                    variant="outline"
                    size="sm"
                    className="h-7 px-2"
                    onClick={onNext}
                    disabled={currentPage === totalPages - 1}
                >
                    <ChevronRight className="size-4" />
                    <span className="sr-only">Next Page</span>
                </Button>
            </div>
        </CardFooter>
    )
}
